import {PrintOrder, ViewOrderItems} from 'app/features/orders/componentsv1'
import {orderFulfillmentStatusTypes, orderType} from 'app/features/orders/models'
import {ViewOrder} from 'app/features/orders/models/OrderState'
import {mapToFulfilledItemsModel} from 'app/features/orders/redux/order/helper'
import Tracking from '../FulfillmentList/Tracking'
import _ from 'lodash'
import {useMemo, useState} from 'react'
import InventoryLocationChange from './InventoryLocationChange'
import {CreateRefund} from '../orderActions/components'
import {fulfillmentStatusTypes, paymentStatusTypes} from 'app/constant'

interface Props {
  viewOrder: ViewOrder
  isPosPickup: boolean
}

export const ViewFulfilledItems: React.FC<Props> = ({viewOrder, isPosPickup}) => {
  const [dialogOpen, setDialogOpen] = useState(false)
  const [fulfillmentLocation, setFulfillmentLocation] = useState({
    fulfillmentId: '',
    currentLocation: '',
  })

  const handleOpenLocationDialog = (fulfillment: any) => {
    setFulfillmentLocation({fulfillmentId: fulfillment.id, currentLocation: fulfillment.locationId})
    setDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setDialogOpen(false)
  }

  const fulfillments = useMemo(() => {
    return viewOrder.fulfillments.map((fulfillment: any) => {
      const items = _.flattenDeep(fulfillment.fulfillmentItems.nodes).filter(function () {
        return true
      })
      const fulfillmentItems: any = mapToFulfilledItemsModel(items).filter(
        (fulfillment) => fulfillment.quantity > 0
      )
      return {...fulfillment, fulfillmentItems}
    })
  }, [viewOrder.fulfillments])

  return (
    <>
      {!isPosPickup &&
        (viewOrder.fulfillmentStatus === orderFulfillmentStatusTypes.fulfilled ||
          viewOrder.fulfillmentStatus === orderFulfillmentStatusTypes.partial) &&
        fulfillments
          .filter(({fulfillmentItems}: any) => fulfillmentItems.length > 0)
          .map((fulfillment) => {
            return (
              <ViewOrderItems
                items={fulfillment.fulfillmentItems}
                title={
                  fulfillment.isPickup
                    ? 'Pickup Fulfilled'
                    : viewOrder.orderType === orderType.pos
                    ? 'Shipping Fulfilled'
                    : 'Fulfilled'
                }
                toolbar={
                  <div className='d-flex align-items-center mb-3 gap-4'>
                    {viewOrder.orderType !== orderType.pos &&
                      (!viewOrder.isDisableEdit ||
                        viewOrder.financialStatus !== paymentStatusTypes.refunded) && (
                        <CreateRefund fulfillmentId={fulfillment.id} />
                      )}
                    <PrintOrder
                      order={viewOrder}
                      fulfillment={fulfillment}
                      handleOpenLocationDialog={handleOpenLocationDialog}
                      isPos={viewOrder.orderType === orderType.pos && fulfillment.isPickup}
                    />
                  </div>
                }
                subTitle={
                  viewOrder.invoiceNumber && (
                    <span className='text-muted fw-bold text-muted d-block fs-7'>
                      Invoice - # {viewOrder.invoiceNumber}
                    </span>
                  )
                }
              >
                <Tracking
                  url={fulfillment.trackingUrl}
                  companyName={fulfillment.trackingCompanyName}
                  tracking={fulfillment.tracking}
                />
              </ViewOrderItems>
            )
          })}
      <InventoryLocationChange
        show={dialogOpen}
        onClose={handleCloseDialog}
        fulfillmentLocation={fulfillmentLocation}
        setFulfillmentLocation={setFulfillmentLocation}
      />
    </>
  )
}

export default ViewFulfilledItems
